import { SafeHtml } from '@angular/platform-browser';

export type Html = string | SafeHtml;
export type HexColor = string;